import React, { FC } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScannerCaseConstructionType } from 'models/scanner-case';

type ScannerCaseConstructionTypesProps = {
    constructionTypes?: ScannerCaseConstructionType[];
};

// DD-3445: the distinct constructions of a scanner case, one per line. Mapped
// types use the Denthub restoration-type translations; unmapped ones show the
// scanner's own label. Panda cases carry no type and show "Not specified".
const ScannerCaseConstructionTypes: FC<ScannerCaseConstructionTypesProps> = ({ constructionTypes }) => {
    const { t: translate } = useTranslation(['scan-cases', 'restoration-types']);

    if (!constructionTypes || constructionTypes.length === 0) {
        return (
            <Typography variant="body2" color="grey.700">
                {translate('scan-cases:NOT_SPECIFIED')}
            </Typography>
        );
    }

    const labels = constructionTypes.map((constructionType) =>
        constructionType.restorationType
            ? translate(`restoration-types:${constructionType.restorationType}`).toString()
            : constructionType.label,
    );

    return (
        <Tooltip title={labels.join(', ')}>
            <Box>
                {labels.map((label, labelIndex) => (
                    <Box
                        key={`${label}-${labelIndex}`}
                        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {label}
                    </Box>
                ))}
            </Box>
        </Tooltip>
    );
};

export default ScannerCaseConstructionTypes;
